export default "__VITE_ASSET__DSI2GYHk__"